import type { IPickupStatus, IQuantityType } from '~~/shared/interfaces/dictionaries'; // adjust the import path as needed

export const useDictionariesStore = defineStore('dictionaries', () => {
	const nuxtApp = useNuxtApp();
	const pickupStatuses = ref<Map<string, IPickupStatus> | null>(null);
	const storekeeperStatuses = ref<Map<string, any> | null>(null);
	const quantityType = ref<IQuantityType[] | null>(null);
	const loading = reactive({
		pickupStatuses: false
	});

	function $reset() {
		pickupStatuses.value = null;
		storekeeperStatuses.value = null;
		quantityType.value = null;
	}

	const getQuantityType = async () => {
		console.log('IQuantityType');
		const { data, status } = await useCustomFetch<IQuantityType[]>(
			'/api/QuantityType/get-lookups',
			{
				watch: false,
				server: true,

				getCachedData(key) {
					const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key];
					if (!data || !data?.size) return;
					return data;
				}
			},
			{
				setLoading: (load: boolean) => {}
			}
		);

		if (status.value === 'success' && data?.value) {
			quantityType.value = data.value;
		}
	};

	/**
	 * get all pickupStatuses list
	 */
	const getPickupStatuses = async () => {
		const { data, status } = await useCustomFetch<any>(
			'/api/Status/get-pickup-statuses',
			{
				watch: false,
				server: false,

				transform(data: IPickupStatus[]): Map<string, IPickupStatus> {
					return new Map(
						data.map((obj) => {
							return [obj.id, obj];
						})
					);
				},

				getCachedData(key) {
					const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key];
					if (!data || !data?.size) return;
					return data;
				}
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.pickupStatuses = load;
					}
				}
			}
		);

		if (status.value === 'success' && data?.value) {
			pickupStatuses.value = data.value;
		}
	};

	const getStorekeeperStatuses = async () => {
		const { data, status } = await useCustomFetch<any>(
			'/api/Status/get-storekeeper-statuses',
			{
				watch: false,
				server: true,

				transform(data: IPickupStatus[]): Map<string, IPickupStatus> {
					return new Map(
						data.map((obj) => {
							return [obj.id, obj];
						})
					);
				},

				getCachedData(key) {
					const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key];
					if (!data || !data?.size) return;
					return data;
				}
			},
			{
				setLoading: (load: boolean) => {
					if (true) {
						loading.pickupStatuses = load;
					}
				}
			}
		);

		if (status.value === 'success' && data?.value) {
			storekeeperStatuses.value = data.value;
		}
	};

	return {
		pickupStatuses,
		storekeeperStatuses,
		quantityType,
		loading,
		$reset,
		getPickupStatuses,
		getStorekeeperStatuses,
		getQuantityType
	};
});
